export let exportMenu = [
	{
		url: "/dashboard",
		i18n: "HOME",
		icon: "uil-home-alt",
		active: false,
		adminOnly: true

	},
	{
		url: "/admin/clients",
		i18n: "ADMIN",
		icon: "uil-users-alt",
		active: false,
		adminOnly: true
	},
	{
		url: "/pos",
		i18n: "POSES",
		icon: "uil-shop",
		active: false,
		adminOnly: false
	},
	{
		url: "/payments",
		i18n: "PAYMENTS",
		icon: "uil-money-bill",
		active: false,
		adminOnly: true
	},
	{
		url: "/newPayments",
		i18n: "OBUNALAR",
		icon: "uil-money-bill",
		active: false,
		adminOnly: true
	},
	{
		url: "/admin/debt/excel",
		i18n: "DEBTOR",
		icon: "uil-file-alt",
		active: false,
		adminOnly: true
	},
	{
		url: "/products",
		i18n: "PRODUCTS",
		icon: "uil-shopping-cart",
		active: false,
		adminOnly: true
	},
	{
		url: "/product-categories",
		i18n: "PRODUCT_CATEGORIES",
		icon: "uil-apps",
		active: false,
		adminOnly: true
	},
	{
		url: "/accountManager",
		i18n: "CLIENT_ADMIN",
		icon: "uil-user",
		active: false,
		adminOnly: true
	},
	{
		url: "#",
		i18n: "PLAN_FACT",
		icon: "uil-chart-line",
		active: false,
		adminOnly: true,
		children: [
			{
				url: "/plan",
				i18n: "PLAN",
				active: false,
			},
			{
				url: "/fakt",
				i18n: "FAKT",
				active: false,
			},
		]
	},
	{
		url: "/cashboxSettings",
		i18n: "CASHBOX_SETTINGS",
		icon: "uil-setting",
		active: false,
		adminOnly: true
	},
	{
		url: "/didox",
		i18n: "DIDOX",
		icon: "uil-file-download-alt",
		active: false,
		adminOnly: true
	},
	{
		url: "/notification",
		i18n: "NOTIFICATIONS",
		icon: "uil-message",
		active: false,
		adminOnly: true
	},
	{
		url: "/confirmPayments",
		i18n: "CONFIRM_PAYMENTS",
		icon: "uil-money-bill",
		active: false,
		adminOnly: false
	},
	{
		url: "#",
		i18n: "REPORTS",
		icon: "uil-money-bill",
		active: false,
		adminOnly: true,
		children: [
			{
				url: "/reports-monthly",
				i18n: "MONTHLY_REPORTS",
				active: false,
			},
			{
				url: "/reports-integration",
				i18n: "REPORTS_INTEGRATION",
				active: false,
			},
			{
				url: "/reports-dealers",
				i18n: "DEALER_REPORTS",
				active: false,
			}
		]
	},
	{
		url: "/pos-full",
		i18n: "POSES_FULL",
		icon: "uil-shop",
		active: false,
		adminOnly: false
	}
]